
export const versionInfo = {
  version: '0.0.0',
  hash: '4db3cb1',
  timestamp: '6/10/2026, 11:27:09 pm'
};
